module.exports = __webpack_public_path__ + "img/blog11.7c7c42c9.jpeg";